<div *ngIf="ticket.ticket_id">
    <div>
        <div style="display: flex; align-items: center">
            <h1 style="margin-right: 10px" [attr.data-cy]="'bbdbd_h1_1_4_'">VETVET-{{ ticket.ticket_id }}</h1
            ><span class="spacer"></span>
            <div
                [style.border-color]="getColor(ticket.status_id)"
                [style.color]="getColor(ticket.status_id)"
                class="status-field"
            >
                {{ ticket.status }}
            </div>
        </div>
    </div>

    <h2 style="padding-bottom: 25px">{{ ticket.titel }}</h2>

    <div style="border: 1px solid #ccc; border-radius: 8px; padding: 10px; position: relative">
        <div style="position: absolute; top: -10px; left: 10px; background: white; padding: 0 5px">
            <strong>Beschreibung</strong>
        </div>
        <p>{{ ticket.beschreibung }}</p>
    </div>

    <!--  <div style="background: #FAFAFA; padding: 10px;">-->
    <!--    <p>{{ ticket.beschreibung }}</p>-->
    <!--  </div>-->

    <li *ngIf="ticket.status_id != 228" style="margin-top: 12px; list-style: none; padding-top: 25px">
        <div *ngIf="isAdmin">
            <mat-slide-toggle [disabled]="isLoadingOrSaving" [formControl]="neuerKommentarPublicCtrl"
                ><span>&Ouml;ffentlich</span>
            </mat-slide-toggle>
        </div>
        <mat-form-field *kienePermission="[10036]" style="width: 100%">
            <mat-label>Kommentar schreiben</mat-label>
            <input
                (keydown.enter)="kommentarCtrl.value ? addComment() : null"
                [disabled]="isLoadingOrSaving"
                [formControl]="kommentarCtrl"
                matInput
                required
                [attr.data-cy]="'bbdbd_input_1_1_'"
            />
            <button
                (click)="addComment()"
                [disabled]="isLoadingOrSaving"
                color="accent"
                mat-icon-button
                matSuffix
                [attr.data-cy]="'bbdbd_button_1_0_'"
            >
                <mat-icon [attr.data-cy]="'bbdbd_mat-icon_1_2_'">send</mat-icon>
            </button>
        </mat-form-field>
    </li>

    <li *kienePermission="[10033]" style="margin-top: 25px; list-style: none">
        <h2>Kommentare</h2>
        <p *ngIf="!ticket?.kommentare || ticket?.kommentare.length === 0">Keine Kommentare vorhanden</p>
        <ng-container *ngFor="let k of ticket.kommentare; let i = index">
            <div class="one-row" style="margin-bottom: 12px">
                <span style="margin-left: 6px; font-size: 0.8em"
                    ><strong>{{ k.ersteller }}</strong> am: {{ k.erstellt | date: "dd.MM.yyyy HH:mm" }} Uhr</span
                >

                <span class="spacer"></span>
                <ng-container style="min-height: 50px">
                    <button
                        [disabled]="isLoadingOrSaving || !deletableComment(k)"
                        [matMenuTriggerFor]="commentMenu"
                        color="accent"
                        mat-icon-button
                        [attr.data-cy]="'bbdbd_button_2_0_' + i"
                    >
                        <mat-icon [attr.data-cy]="'bbdbd_mat-icon_2_2_' + i">more_vert</mat-icon>
                    </button>
                    <mat-menu #commentMenu="matMenu" style="min-width: 20vw">
                        <button (click)="deleteComment(k)" mat-menu-item [attr.data-cy]="'bbdbd_button_3_0_' + i">
                            <mat-icon [attr.data-cy]="'bbdbd_mat-icon_3_2_' + i">delete</mat-icon>
                            löschen
                        </button>
                    </mat-menu>
                </ng-container>
            </div>
            <div class="one-row">
                <span style="margin-left: 6px; white-space: pre-wrap">{{ k.kommentar }}</span>
                <mat-icon
                    *ngIf="!k.oeffentlich"
                    matTooltip="Interner Kommentar"
                    style="margin-left: 12px; transform: scale(0.7)"
                    [attr.data-cy]="'bbdbd_mat-icon_4_2_'"
                >
                    visibility_off
                </mat-icon>
            </div>
            <mat-divider></mat-divider>
        </ng-container>
    </li>
    <div style="text-align: right">
        <button (click)="onNoClick()" mat-button style="margin-top: 25px" [attr.data-cy]="'bbdbd_button_4_0_'"
            >Schließen</button
        >
    </div>
</div>
